import React from 'react'
import { createPortal } from 'react-dom'
import useStore from 'state/knovStore'
import ConfirmTray from 'components/quests/ConfirmTray'

export default function TrayHost() {
    const isTrayOpen = useStore(state => state.isTrayOpen)
    const trayParams = useStore(state => state.trayParams)
    const closeTray = useStore(state => state.actions.trayActions.closeTray)

    if (!isTrayOpen || !trayParams) return null

    const tray =
        trayParams.type === 'Confirm' ? (
            <ConfirmTray trayParams={trayParams} closeTray={closeTray} />
        ) : null

    if (!tray) return null

    // A tray may name where it renders: inside a fullscreen viewer, which sits in the browser's
    // top layer, it shows above the viewer instead of behind it.
    const container =
        trayParams.container instanceof HTMLElement && trayParams.container.isConnected
            ? trayParams.container
            : document.body
    return createPortal(tray, container)
}
